
import React, { Component}  from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextWidget } from 'form/Contexed';
import { InputWidget } from "form/InputWidget";
import ScheduleForm from './ScheduleForm';


export default class TransportOrderForm extends Component {

  handleChange = (context, schedule, handleClose) => {
    if (schedule) {
      context.setValues({
        schedule: schedule.schedule,
        driver: schedule.driver,
        tractor_unit: schedule.tractor_unit,
        semi_trailer: schedule.semi_trailer,
      });
    }
    else {
      context.setValues({
        schedule: null,
        driver: null,
        tractor_unit: null,
        semi_trailer: null
      });
    }
    handleClose();
  }

  render() {
    return (
      <FormContext.Consumer>
        {context => {
          const { item } = context;
          return (
            <React.Fragment>

              <ScheduleForm
                context={context}
                onChange={(schedule, handleClose) => this.handleChange(context, schedule, handleClose)}
                confirmationRequired={false}
              />

              <React.Fragment>
                <ContextWidget
                  name={`driver`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Водитель',
                    value: item.driver?.full_name,
                    onChange: () => null
                  }}
                />

                <ContextWidget
                  name={`tractor_unit`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Транспортное средтсво',
                    value: item.tractor_unit?.label,
                    onChange: () => null
                  }}
                />

                <ContextWidget
                  name={`semi_trailer`}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Полуприцеп',
                    value: item.semi_trailer?.label,
                    onChange: () => null
                  }}
                />

              </React.Fragment>
            </React.Fragment>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
